<nav>
  <div class="navbar-links-left">
    <a href="#about" class="navbar-link">{{strings.about}}</a>
    <a href="#work" class="navbar-link">{{strings.portfolio}}</a>
    <a href="#skills" class="navbar-link">{{strings.skills}}</a>
    <button class="navbar-link" (click)="setTranslation('en')">&lt; En &gt;</button>
  </div>
  <div class="navbar-center">
  </div>
  <div class="navbar-links-right">
    <button class="navbar-link" (click)="setTranslation('ba')">&lt; Ba &gt;</button>
    <a href="#experience" class="navbar-link">{{strings.experience}}</a>
    <a href="#education" class="navbar-link">{{strings.education}}</a>
    <a href="#certificates" class="navbar-link">{{strings.certificates}}</a>
  </div>
</nav>
